
export default class CascadeModel {
  constructor() {
    this._data = {
      isCascade: false,
      components: [],
      wins: [],
      positions: [],
      multipliers: [],
      matrix: [],
      spinsFinished: [],
      disappears: false,
      dissaperIndex: 0,
      all: -1,
      currentCascade: 0,

    }
  }

  get() {
    return this._data
  }

  checkIsCascade(data) {
    if (data.type === 'cascadelines') {
      this._data.isCascade = true
    }
  }

  set(context) {
    if (this._data.isCascade) {
      this._data.components = []
      this._data.wins =  []
      this._data.positions = []
      this._data.multipliers = []
      this._data.matrix = []
      this._data.spinsFinished = []
      this._data.disappears = false
      this._data.dissaperIndex = 0
      this._data.currentCascade = 0
      this._data.all = -1

      if(context.features && context.features.length > 0){
        this.parseFeature(context.features)

      }

      if(context.win){
        this._data.wins.push(context.win)
      }

      if (context.components && context.components.length > 0) {
        this._data.components = context.components

        this.parseComponents(context.components)

        if(this._data.positions.length > 0){
          this._data.all = this._data.positions.length - 1
        }
        else {
          this._data.all = -1
        }

      }
      else {
        this._data.components = []
        this._data.wins =  []
        this._data.positions = []
        this._data.multipliers = []
        this._data.matrix = []
        this._data.spinsFinished = []
        this._data.disappears = false
        this._data.dissaperIndex = 0
        this._data.currentCascade = 0
        this._data.all = -1
      }
    }
  }

  parseFeature(features){
    features.forEach((features) => {

      if(features.type === 'cascade'){
        this._data.disappears = true
        this._data.positions.push(features.positions)
      }
      if(features.type === 'collectible' && features.name === 'progressiveMultiplier'){
        this._data.multipliers.push(features.value)
      }
    })
  }

  parseComponents(components){
    components.forEach((component) => {
      if(component.mode === 'component'){
        if(component.hasOwnProperty('win')) {
          this._data.wins.push(component.win)
        }
        if(component.hasOwnProperty('matrix')) {
          this._data.matrix.push(component.matrix)
        }
        if(component.hasOwnProperty('finished')) {
          this._data.spinsFinished.push(component.finished)
        }
      }

      if(component.hasOwnProperty('features')) {
        component.features.forEach((features) => {
          if(features.type === 'cascade'){
            this._data.positions.push(features.positions)
          }
          if(features.type === 'collectible' && features.name === 'progressiveMultiplier'){
            this._data.multipliers.push(features.value)
          }

        })
      }

    })
  }

}
